import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { ASSETS_PATH } from '../../services/endpoints';
import { myTokensMobileStyles } from './myTokensMobilestyles';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import useMediaQuery from '@mui/material/useMediaQuery';
import { selectBalance } from '../../store/vestingInfo/vestingInfoSlice';

export const MyTokensMobile = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const classes = myTokensMobileStyles(theme);
  const avatarImage = `${ASSETS_PATH}/img/favicon.png`;
  const avatarImageBnb = `${ASSETS_PATH}/img/bnb_logo.png`;
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'));
  const typographyVariant = isDownSm ? 'body2' : 'body1';
  const balance = useSelector(selectBalance);
  return (
    <Grid
      item
      container
      alignItems='center'
      direction='row'
      sx={classes.container}
      columnSpacing={2}
      rowSpacing={1}
    >
      <Grid item sx={classes.title}>
        <Typography variant={typographyVariant}>
          {t('vesting.amount.title')}
        </Typography>
      </Grid>
      <Grid
        item
        container
        sx={classes.dataContainer}
        columnSpacing={2}
        rowSpacing={1}
      >
        <>
          <Grid
            item
            container
            direction='row'
            wrap='nowrap'
            sx={classes.dataItem}
          >
            <Grid item>
              <Avatar
                sx={classes.tokenImage}
                alt='STO Image'
                src={avatarImage}
              />
            </Grid>
            <Grid item>
              <Typography
                variant='subtitle1'
                color={theme.palette.text.primary}
                sx={classes.amount}
              >
                {balance?.bknAmount}
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                color='secondary'
                variant='subtitle1'
                sx={classes.unit}
              >
                {t('vesting.amount.unit.bkn')}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            container
            direction='row'
            wrap='nowrap'
            sx={classes.dataItem}
          >
            <Grid item>
              <Avatar
                sx={classes.tokenImage}
                alt='STO Image'
                src={avatarImageBnb}
              />
            </Grid>
            <Grid item>
              <Typography
                variant='subtitle1'
                color={theme.palette.text.primary}
                sx={classes.amount}
              >
                {balance?.bnbAmount}
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                color='secondary'
                variant='subtitle1'
                sx={classes.unit}
              >
                {t('vesting.amount.unit.wbkn')}
              </Typography>
            </Grid>
          </Grid>
        </>
      </Grid>
    </Grid>
  );
};
